import React from 'react';
import { Button, Stack, Box, Typography } from '@mui/material';
import { faMapLocationDot } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getRuta } from '../../../../helpers/Helpers';
import { accionPrincipalSx } from '../../../../components/ui/accionPrincipal';

// No hay nada que seleccionar: el mapa muestra a todos los gestores de las sucursales del
// usuario y siempre la jornada de hoy. Se conserva el paso del selector para que el
// reporte se abra igual que los demas.
const SelectorGestoresEnVivo = () => {
	let ruta = getRuta();

	return (
		<div>
			<Box sx={{ width: '100%', maxWidth: 550 }}>
				<Stack spacing={2}>
					<Typography variant="body2" textAlign={'center'}>
						Muestra la última ubicación conocida de cada gestor en la jornada de hoy y
						se actualiza cada minuto.
					</Typography>

					<Button
						variant="contained"
						startIcon={<FontAwesomeIcon icon={faMapLocationDot} />}
						onClick={() => window.open(`${ruta}/r-gestoresenvivo`)}
						sx={accionPrincipalSx}
					>
						Ver Mapa en Vivo
					</Button>
				</Stack>
			</Box>
		</div>
	);
};

export default SelectorGestoresEnVivo;
